import Select from './Select'
import type { Filter } from '@/shared/hooks/useQueryParams'

type Option<T extends string> = {
    value: T
    label: string
}

export type FilterSelectProps<T extends string> = {
    filter: Filter<T>
    placeholder?: string
    'data-testid'?: string
}

export function FilterSelect<T extends string>({
    filter,
    placeholder,
    'data-testid': dataTestId
}: FilterSelectProps<T>) {
    const { items, value, onChange, getLabel, type } = filter

    const options: Option<T>[] = items.map((item) => ({
        value: item,
        label: getLabel(item)
    }))

    const selected: Option<T>[] = (value ?? []).map((v) => ({
        value: v,
        label: getLabel(v)
    }))

    if (type === 'multi') {
        return (
            <Select<Option<T>, true>
                data-testid={dataTestId}
                isMulti
                isClearable
                isSearchable={false}
                placeholder={placeholder}
                value={selected}
                options={options}
                onChange={onChange}
            />
        )
    } else {
        return (
            <Select<Option<T>>
                data-testid={dataTestId}
                isMulti={false}
                isClearable
                isSearchable={true}
                placeholder={placeholder}
                value={selected[0] ?? null}
                options={options}
                onChange={onChange}
            />
        )
    }
}
